import { render } from "./TicketComponent.vue?vue&type=template&id=7219c34e"
import script from "./TicketComponent.vue?vue&type=script&lang=js"
export * from "./TicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__